export default __webpack_public_path__ + "static/media/Karekter-1.68598db5.png";